import config from "config";

export const appName = config.appName
    ? config.appName + "-webui"
    : "interaction-details-ui-webui";
const appVersion =
    config.appVersion === "dev" ? config.appVersion : config.packageVersion;

export const genesysApp = `${appName}/${appVersion}`;
